import React from 'react';
import Preferences from '../components/Preferences';

const Settings = () => {
  return <Preferences />;
};

export default Settings;
